import { APICallV3Post } from 'reactApp/api/APICall';

export class SubscriptionNoRenewAPICall extends APICallV3Post {
    _method = 'billing/subscription/norenew';
}

